// extracted by mini-css-extract-plugin
export var circle = "_bc-1";
export var exitConfirmationModal = "_bc-5";
export var iframe = "_bc-0";
export var offline = "_bc-3";
export var online = "_bc-2";
export var workstationSelectError = "_bc-4";